import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {EsimUpgradePages, EsimPriceApiStatus, InnerPopupTypes, EsimUpgradeEligibilityApiStatus} from './enums/enums';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {selfServiceDwh} from 'app/utilities/SelfServiceDwh';
export const getEsimPriceIfPreChecksPass = createAsyncThunk(
  'BusinessClientEsimUpgradeSlice/getEsimPriceIfPreChecksPass',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      var result = await ProviderManager.getProviderData('getEsimPriceIfPreChecksPass', [data.subscriberNumber, data.upgKey, data.upgKeyTheftOrLoss, data.contactOrgId]);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);
export const isSubscriberEligibleForEsimUpgrade = createAsyncThunk(
  'BusinessClientEsimUpgradeSlice/isSubscriberEligibleForEsimUpgrade',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      var result = await ProviderManager.getProviderData('isSubscriberEligibleForEsimUpgrade', [data.subscriberNumber]);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);
export const sendOrderForEsimUpgrade = createAsyncThunk(
  'BusinessClientEsimUpgradeSlice/sendOrderForEsimUpgrade',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      var result = await ProviderManager.getProviderData('sendOrderForEsimUpgrade', [
        data.subscriberNumber,
        data.otpPhone,
        data.dispRsn,
        data.upgCourse,
        data.productId,
        data.package,
        data.combSeq,
      ]);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);

const initialState = {
  subscriberNumber: '',
  esimPriceApiResponse: {
    esimPrice: '',
    simSerialNumber: null,
    differentOrgName: '',
    differentOrgId: '',
    isSuspendedTheftOrLoss: false,
    isSubscriberActive: false,
  },
  currentPage: EsimUpgradePages.WelcomePage,
  showInnerPopup: false,
  innerPopupType: InnerPopupTypes.NoPopup,
  isPopupCloseBtnClicked: false,
};

const BusinessClientEsimUpgradeSlice = createSlice({
  name: 'BusinessClientEsimUpgradeSlice',
  initialState: initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      const key = action.payload;
      if (key in EsimUpgradePages) {
        state.currentPage = action.payload;
      }
    },
    setShowInnerPopup: (state, action) => {
      state.showInnerPopup = action.payload;
    },
    setInnerPopupType: (state, action) => {
      state.innerPopupType = action.payload;
    },
    setSubscriberNumber: (state, action) => {
      state.subscriberNumber = action.payload;
    },
    setPopupCloseBtnClicked: (state, action) => {
      state.isPopupCloseBtnClicked = action.payload;
    },
    resetPopupInfo: (state) => {
      state.showInnerPopup = false;
      state.innerPopupType = InnerPopupTypes.NoPopup;
    },
    resetState: (state) => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getEsimPriceIfPreChecksPass.fulfilled, (state, action) => {
        const {status, data} = action.payload || {};

        switch (status) {
          case EsimPriceApiStatus.NoError: {
            state.esimPriceApiResponse.esimPrice = data.esimPrice;
            state.esimPriceApiResponse.simSerialNumber = data.simSerialNumber;
            state.esimPriceApiResponse.isSubscriberActive = true;
            state.currentPage = EsimUpgradePages.ChoseEsimOrSim;
            state.showInnerPopup = false;
            state.innerPopupType = InnerPopupTypes.NoPopup;
            break;
          }
          case EsimPriceApiStatus.SuspendedTheftOrLoss: {
            state.esimPriceApiResponse.esimPrice = data.esimPrice;
            state.esimPriceApiResponse.simSerialNumber = null;
            state.esimPriceApiResponse.isSuspendedTheftOrLoss = true;
            state.currentPage = EsimUpgradePages.ChoseEsimOrSim;
            state.showInnerPopup = true;
            state.innerPopupType = InnerPopupTypes.SuspendedTheftOrLoss;
            break;
          }
          case EsimPriceApiStatus.Suspended: {
            state.currentPage = EsimUpgradePages.Suspended;
            state.showInnerPopup = false;
            state.innerPopupType = InnerPopupTypes.NoPopup;
            state.esimPriceApiResponse.simSerialNumber = null;
            break;
          }
          case EsimPriceApiStatus.NotBelongToOrg: {
            state.currentPage = EsimUpgradePages.NotBelongToOrg;
            state.showInnerPopup = false;
            state.innerPopupType = InnerPopupTypes.NoPopup;
            state.esimPriceApiResponse.simSerialNumber = null;
            break;
          }
          case EsimPriceApiStatus.BelongToDifferentOrg: {
            state.esimPriceApiResponse.differentOrgName = data.orgName;
            state.esimPriceApiResponse.differentOrgId = data.orgId;
            state.currentPage = EsimUpgradePages.BelongToDifferentOrg;
            state.showInnerPopup = false;
            state.innerPopupType = InnerPopupTypes.NoPopup;
            state.esimPriceApiResponse.simSerialNumber = null;
            break;
          }
          case EsimPriceApiStatus.Provider1428RelatedError:
          case EsimPriceApiStatus.Provider835RelatedError:
          case EsimPriceApiStatus.GeneralError:
          default: {
            state.currentPage = EsimUpgradePages.GeneralError;
            state.showInnerPopup = false;
            state.innerPopupType = InnerPopupTypes.NoPopup;
            state.esimPriceApiResponse.simSerialNumber = null;
            break;
          }
        }
      })
      .addCase(getEsimPriceIfPreChecksPass.rejected, (state, action) => {
        state.showInnerPopup = true;
        state.innerPopupType = InnerPopupTypes.GeneralError;
      })
      .addCase(isSubscriberEligibleForEsimUpgrade.fulfilled, (state, action) => {
        const {status, data} = action.payload || {};

        switch (status) {
          case EsimUpgradeEligibilityApiStatus.NoError: {
            state.currentPage = EsimUpgradePages.ChangeToEsim;
            state.showInnerPopup = false;
            state.innerPopupType = InnerPopupTypes.NoPopup;
            break;
          }

          case EsimUpgradeEligibilityApiStatus.SubscriberIsAbroad: {
            state.currentPage = EsimUpgradePages.SubscriberIsAbroad;
            state.showInnerPopup = false;
            state.innerPopupType = InnerPopupTypes.NoPopup;
            break;
          }

          case EsimUpgradeEligibilityApiStatus.SubscriberIsInNiudProcess: {
            state.currentPage = EsimUpgradePages.SubscriberIsInNiudProcess;
            state.showInnerPopup = false;
            state.innerPopupType = InnerPopupTypes.NoPopup;
            break;
          }

          case EsimUpgradeEligibilityApiStatus.GeneralError:
          default: {
            state.currentPage = EsimUpgradePages.GeneralError;
            state.showInnerPopup = false;
            state.innerPopupType = InnerPopupTypes.NoPopup;
            break;
          }
        }
      })
      .addCase(isSubscriberEligibleForEsimUpgrade.rejected, (state, action) => {
        state.showInnerPopup = true;
        state.innerPopupType = InnerPopupTypes.GeneralError;
      })
      .addCase(sendOrderForEsimUpgrade.fulfilled, (state, action) => {
        const res = action.payload;
        if (res?.header?.returnCode === '00') {
          selfServiceDwh.UpgradeEsim.Upgrade({_subscriber: action.meta.arg?.subscriberNumber});
          state.currentPage = EsimUpgradePages.ChangeToEsimSuccess;
          state.showInnerPopup = false;
          state.innerPopupType = InnerPopupTypes.NoPopup;
        } else {
          state.currentPage = EsimUpgradePages.GeneralError;
          state.showInnerPopup = false;
          state.innerPopupType = InnerPopupTypes.NoPopup;
        }
      })
      .addCase(sendOrderForEsimUpgrade.rejected, (state, action) => {
        state.currentPage = EsimUpgradePages.GeneralError;
        state.showInnerPopup = false;
        state.innerPopupType = InnerPopupTypes.NoPopup;
      })
  },
});

export const {
  setCurrentPage,
  setShowInnerPopup,
  setInnerPopupType,
  setPopupCloseBtnClicked,
  setSubscriberNumber,
  resetPopupInfo,
  resetState,
} = BusinessClientEsimUpgradeSlice.actions;

export default BusinessClientEsimUpgradeSlice.reducer;
